import { LookupModelSearchEvent } from "@mcleod/components";
import { getDispatchControlBoolean } from "@mcleod/general";
import { AutogenLayoutTractorRevenueReport } from "./autogen/AutogenLayoutTractorRevenueReport";

export class TractorRevenueReport extends AutogenLayoutTractorRevenueReport {
    _containerEnabled: boolean;

    override onLoad(): void | Promise<void> {
        this.textboxDateType.selectedItem = this.textboxDateType.items[0];
        this.textboxIncludeContainers.selectedItem = this.textboxIncludeContainers.items[0];
        this.textboxGroupBy.selectedItem = this.textboxGroupBy.items[0];
        this.textboxPayeeOption.selectedItem = this.textboxPayeeOption.items[0];
        this._containerEnabled = getDispatchControlBoolean("is_container_active", false);
        this.toggleContainerEnabled(this._containerEnabled);
    }

    private toggleContainerEnabled(isEnabled: boolean) {
        this.excludabletextboxSteamshipLine.enabled = isEnabled;
        this.excludabletextboxSteamshipLine.visible = isEnabled;
        this.textboxIncludeContainers.enabled = isEnabled;
        this.textboxIncludeContainers.visible = isEnabled;
    }

    textboxSteamshipLineBeforeLookupModelSearch(event: LookupModelSearchEvent) {
        event.filter.is_steamship = "Y"
    }

    excludabletextboxFleetIdTextboxBeforeLookupModelSearch(event: LookupModelSearchEvent) {
        event.filter.is_trailer = "Y"
    }

    textboxIncludeContainerDropdownSelectionChanged(event: EventListener) {
        if (this.textboxIncludeContainers.selectedItem && this.textboxIncludeContainers.selectedItem.value == "N") {
            this.excludabletextboxSteamshipLine.textbox.clear();
            this.excludabletextboxSteamshipLine.textbox.enabled = false;
        }
        else {
            this.excludabletextboxSteamshipLine.textbox.enabled = true;
        }
    }

    textboxGroupByDropdownSelectionChanged(event: EventListener) {
        if (this.textboxGroupBy.selectedItem && (this.textboxGroupBy.selectedItem.value == "N" || this.textboxGroupBy.selectedItem.value == "P")) {
            this.checkboxPageBreak.checked = false;
            this.checkboxPageBreak.enabled = false;
        }
        else {
            this.checkboxPageBreak.enabled = true;
        }
    }
}
